import { render, staticRenderFns } from "./add_rootcase.vue?vue&type=template&id=26cb22a0&scoped=true&"
import script from "./add_rootcase.vue?vue&type=script&lang=js&"
export * from "./add_rootcase.vue?vue&type=script&lang=js&"
import style0 from "./add_rootcase.vue?vue&type=style&index=0&id=26cb22a0&lang=less&scoped=true&"
import style1 from "./add_rootcase.vue?vue&type=style&index=1&id=26cb22a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cb22a0",
  null
  
)

export default component.exports